export default "__VITE_ASSET__jhnVIXIw__"